/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconSquareChevronUp = createReactComponent("outline", "square-chevron-up", "IconSquareChevronUp", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M9 13l3 -3l3 3", "key": "svg-1" }]]);

export { IconSquareChevronUp as default };
//# sourceMappingURL=IconSquareChevronUp.mjs.map
